var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-expansion-panel",
    { attrs: { disabled: _vm.disabled } },
    [
      _c("v-expansion-panel-header", {
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function ({ open }) {
                return [
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c("span", { staticStyle: { "margin-top": "5px" } }, [
                        _vm._v(_vm._s(_vm.title)),
                      ]),
                      _c("v-fade-transition", [
                        open & _vm.button_add
                          ? _c(
                              "span",
                              { staticStyle: { display: "inline-flex" } },
                              [
                                _c("v-divider", {
                                  staticClass: "mx-2",
                                  attrs: { vertical: "" },
                                }),
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { color: "primary", small: "" },
                                    nativeOn: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.$emit("click_add")
                                      },
                                    },
                                  },
                                  [_vm._v(" ADD ")]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _c("v-spacer"),
                      _c("v-fade-transition", [
                        open
                          ? _c(
                              "span",
                              { staticStyle: { display: "inline-flex" } },
                              [
                                _vm._t("header"),
                                _c("v-divider", {
                                  staticClass: "mx-1",
                                  attrs: { vertical: "" },
                                }),
                              ],
                              2
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "actions",
              fn: function () {
                return [
                  _c(
                    "v-icon",
                    { attrs: { color: _vm.empty ? "" : "success" } },
                    [_vm._v(" mdi-chevron-down ")]
                  ),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
      _c("v-expansion-panel-content", [_vm._t("default")], 2),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }